import { render, staticRenderFns } from "./addHeho.vue?vue&type=template&id=3cc7ddaa"
import script from "./addHeho.vue?vue&type=script&lang=js"
export * from "./addHeho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports